export const selectUI = (state: any): any => state.ui;
